/**
 * Reducer for explore destinations
 *
 * Copyright (c) 2023 Propellant Software Corp
 * Author: Yucho Ho
 */
import produce from 'immer'
import {
  FETCH_DESTINATION_SUCCESS
} from '../types'

const initialState = {}

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_DESTINATION_SUCCESS:
      const gpid = action.data.details.pid

      // Since normalizr is deprecated, manually massage the data
      const boardsArray = action.data.boards
      const boardsOrder = boardsArray.map(({ bid }) => bid)
      const boardsSet = boardsArray.reduce((acc, board) => {
        return {
          ...acc,
          [board.bid]: board
        }
      }, {})

      draft[gpid] = {
        ...action.data,
        boardsOrder,
        boardsSet
      }
      break
  }
}, initialState)

// ------------------------------------
// Selectors
// ------------------------------------

const selectDestination = (state, gpid) => {
  return state[gpid]
}

export const selectors = {
  selectDestination
}
